import * as React from "react";
function SvgSortNoneIcon(props: React.SVGProps<SVGSVGElement>) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={8.792} height={14.511} viewBox="0 0 8.792 14.511" {...props}><path d="M14,20l4.4,5.374L22.792,20Z" transform="translate(-14 -10.863)" /><path d="M14,25.374,18.4,20l4.4,5.374Z" transform="translate(-14 -20)" /></svg>;
}
export default SvgSortNoneIcon;